import React, { forwardRef } from "react";
import type { CSSProperties, ImgHTMLAttributes } from "react";

type StaticImport = { src: string; width?: number; height?: number };

export type ImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height" | "placeholder"> & {
  src: string | StaticImport;
  width?: number | `${number}`;
  height?: number | `${number}`;
  fill?: boolean;
  priority?: boolean;
  quality?: number | `${number}`;
  unoptimized?: boolean;
  placeholder?: string;
  blurDataURL?: string;
};

const FILL_STYLE: CSSProperties = { position: "absolute", inset: 0, width: "100%", height: "100%" };

/** Substituto do next/image: <img> nativo (sem otimização de servidor). */
const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(
  { src, fill, priority, quality: _quality, unoptimized: _unoptimized, placeholder: _placeholder, blurDataURL: _blur, style, loading, ...rest },
  ref,
) {
  const source = typeof src === "string" ? src : src.src;
  return (
    <img
      ref={ref}
      src={source}
      loading={loading ?? (priority ? "eager" : "lazy")}
      decoding="async"
      style={fill ? { ...FILL_STYLE, ...style } : style}
      {...rest}
    />
  );
});

export default Image;
